import DOMPurify from "dompurify";

// Post bodies are HTML written in the CMS editor. Only this small subset is
// kept; everything else (scripts, styles, event handlers, iframes...) is removed.
const ALLOWED_TAGS = [
  "p", "br", "div",
  "b", "strong", "i", "em", "u",
  "a", "img",
  "ul", "ol", "li",
  "table", "thead", "tbody", "tr", "th", "td",
];

const ALLOWED_ATTR = ["href", "src", "alt", "title", "colspan", "rowspan"];

// Links open in a new tab without giving the target page access to ours.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || "", { ALLOWED_TAGS, ALLOWED_ATTR });
}

export function escapeHtml(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function textToHtml(text) {
  return escapeHtml(text).replace(/\r?\n/g, "<br>");
}

// Older posts are plain text; turn their line breaks into <br> so they still
// render (and edit) the way they were written.
export function postBodyHtml(body) {
  const text = body || "";

  if (/<[a-z][\s\S]*>/i.test(text)) {
    return sanitizeHtml(text);
  }

  return textToHtml(text);
}

// True when the HTML has no visible text and no images, e.g. "<p><br></p>".
export function isEmptyHtml(html) {
  const doc = new DOMParser().parseFromString(html || "", "text/html");
  return !doc.body.textContent.trim() && !doc.body.querySelector("img");
}
